var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVideoOff = function SvgVideoOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3 10c0-.5-.4-1-.9-1H7.8l11.6 11.6V10zM18.9 22.7l-6.4-6.4-9.8-9.8c-.4-.4-1-.4-1.3 0-.4.4-.4 1-.1 1.3l20.8 20.8c.4.4 1 .4 1.3 0 .4-.4.4-1 0-1.3l-4.5-4.6zM27.5 8.6c-.2 0-.5.1-.7.2l-6.1 5.5v3.2l6.1 5.5c.5.4 1.2.2 1.6-.3.1-.2.2-.4.2-.6V9.8c0-.6-.5-1.2-1.1-1.2zM13.9 22.9 3.3 12.4v-.1 9.6c0 .2 0 .3.1.4 0 .1.1.2.1.2l.1.1.1.1h.4l9.8.2z"
  })));
};
export default SvgVideoOff;